<template>
  <Modal v-bind="$attrs" v-on="$listeners" @closed="closed">
    <div v-if="loading" class="loading-mask">
      Loading...
    </div>
    
    <template #title>担当エリア設定</template>
    <template #subtitle><span class="font-bold">勤怠採用課・建物管理部所属スタッフ<span class="text-red-600">（兼任含む）</span>＊デンタツ、清掃員雇入れの得意先様へメール通知にて建物管理部のみ使用＊</span></template>
    
    <div class="overflow-auto rounded ">
      <div v-for="(depName, i) in Object.keys(list)" :key="i" class="mb-5 p-2 border-2  rounded">
        <!-- 部署名 -->
        <div class="font-bold text-gray-500">{{ depName }}</div>

        <div v-for="(row, j) in list[depName]" :key="i+'row'+j" class="text-sm p-2 ronded mb-3" :class="row.changed?'bg-yellow-50 border border-yellow-500':'bg-blue-100'">
          <div class="flex gap-3 whitespace-nowrap">
            <!-- スタッフ名 -->
            <div class="w-24 self-center font-bold">{{ row.userName }}</div>

            <!-- 追加ボタン -->
            <div @click="addArea(row)" class="cursor-pointer self-center">
              <PlusCircleIcon class="text-indigo-500 active:text-ingigo-600 w-6 h-6"/>
            </div>

            <!-- 東京23区追加ボタン -->
            <div @click="addTokyo23(row)" class="text-blue-700 underline self-center cursor-pointer">東京23区を追加</div>

            <!-- 保存 -->
            <PrimaryButton text="保存" @click="save(row)" size="sm" :disabled="!row.changed" class="mb-1" :class="row.changed?'':'bg-gray-300'" />

            <!-- 兼任部署 -->
            <div v-if="row.departmentName2" class="text-gray-600 text-xs self-center">（兼任：{{ row.departmentName2.join('・') }}）</div>
          </div>

          <div class="flex flex-wrap gap-2">
            <div v-for="(a, k) in row.areas" :key="i+'row'+j+'a'+k" class="flex">
              <input type="text" v-model="row.areas[k]" class="rounded border-gray-300 text-sm text-gray-700" @change="changeText(row)" />
              <TrashIcon class="text-gray-400 cursor-pointer hover:text-gray-500 active:text-gray-600 w-6 h-6 self-center" @click="deleteArea(row, k)"/>
            </div>
          </div>

        </div>
      </div>
      <div class="text-transparent text-xs">{{reload}}</div>
    </div>
  </Modal>
</template>

<script>
import Modal from '@components/Modal.vue'
import PrimaryButton from '@components/PrimaryButton.vue'
import { TrashIcon, PlusCircleIcon  } from '@vue-hero-icons/solid'
import { TOKYO_23 } from '@libs/constants'
import * as backend from '@libs/backend'
export default {
  components: {
    Modal,
    PrimaryButton,
    TrashIcon,
    PlusCircleIcon
  },

  props: ['open'],

  data() {
    return {
      // ローディング
      loading: false,
      reload: 0,
      // 一覧
      list: {}
    }
  },

  watch: {
    async open() {
      if (this.open) {
        await this.getData()
      }
    }
  },

  methods: {
    /**
     * 勤怠、建物部署のユーザー取得
     */
    async getData() {
      this.loading = true
      const result = await backend.searchData('user/getUserByDepartment')
      if (result && result.data.data && result.data.data.length) {
        const res = result.data.data

        const list = {}
        res.forEach(row => {
          if (!list[row.departmentName]) {
            list[row.departmentName] = []
          }
          list[row.departmentName].push(row)
        })

        this.list = list

      } else {
        this.list = {}
      }
      this.loading = false
    },

    /**
     * 担当エリア追加
     */
    addArea(row) {
      row.changed = true
      if (!row.areas) {
        row.areas = []
      }
      row.areas.push('')
    },

    /**
     * 東京23区を追加
     */
    addTokyo23(row) {
      if (!row.areas) {
        row.areas = []
      }
      for (let i = 0; i < TOKYO_23.length; i++) {
        const text = '東京都' + TOKYO_23[i]
        if (!row.areas.includes(text)) {
          row.changed = true
          row.areas.push(text)
        }
      }
    },

    /**
     * エリア削除
     * @param i
     */
    deleteArea(row, i) {
      row.changed = true
      row.areas.splice(i, 1)
      if (!row.areas.length) {
        this.addArea(row)
      }
    },

    /**
     * 
     * @param row テキスト変更イベント
     */
    changeText(row) {
      row.changed = true
      this.reload++
    },

    /**
     * 保存
     * @param row 対象行
     */
    async save(row) {
      this.loading = true
      try {
        const res = await backend.postData('user/saveUserArea', row)
        row.changed = false
        if (res.data.data) {
          row.areas = res.data.data.areas
        }
      } catch (error) {
        alert('もう一度保存をお願いします。')
      }
      this.loading = false
    },

    /**
     * 閉じる
     */
    closed() {
      // ローディング
      this.loading = false
      // 一覧
      this.list = {}
    }
  }
}
</script>
<style scoped>
</style>